import LayoutSidebar from "@/layouts/LayoutSidebar/LayoutSidebar.vue";
import CMSService from "@/services/CMSService";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import BlockQuote from "@/components/BlockQuote/BlockQuote.vue";
import LinkCite from "@/components/LinkCite/LinkCite.vue";
import ArticleTags from "@/components/ArticleTags/ArticleTags.vue";
import RelatedContent from "@/components/RelatedContent/RelatedContent.vue";
import { isSmallDevice, getArticleSlug } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    components: {
        LayoutSidebar,
        Breadcrumb,
        BlockQuote,
        LinkCite,
        ArticleTags,
        RelatedContent,
        Advertising
    },
    data() {
        return {
            layout: LayoutSidebar,
            url: getArticleSlug(this.$route.path),
            title: "",
            articleBody: "",
            articleBodyTop: "",
            articleBodyMiddle: "",
            articleBodyBottom: "",
            tags: [],
            metaTitle: "",
            metaDescription: "",
            canonical: window.location.href,
            disqusCommentsID: ""
        };
    },
    methods: {
        async fetchContent() {
            let promise;
            if (/\/previewArticle/.test(this.$route.params.pathMatch)) {
                promise = CMSService.getArticlePreview(this.$route.query.id);
            } else {
                promise = CMSService.getArticles(this.url);
            }

            try {
                let response = await promise;

                const article = response.data.data;
                this.title = article.title;
                this.articleBody = article.body;
                this.tags = article.tags;

                const firstBreak = /.+?(?=<h2>)/im;
                const secondBreak = /.+?(?=<h2>)/gim;
                const thirdBreak = /^[^]*?<h2>[^]*?(<h2>[^]*?)$/;

                const articleSecondBreak = this.articleBody.match(secondBreak)[1];
                this.articleBodyTop = articleSecondBreak
                    ? this.articleBody.match(firstBreak)[0]
                    : "";
                this.articleBodyMiddle = articleSecondBreak
                    ? this.articleBody.match(secondBreak)[1]
                    : this.articleBody;
                this.articleBodyBottom = articleSecondBreak
                    ? this.articleBody.match(thirdBreak)[1]
                    : "";

                this.metaTitle = article.metaTitle || this.title;
                this.metaDescription =
                    article.metaDescription ||
                    this.$t(`abbreviationsDentalAbbreviationsMetaDescription`);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        },
        getComments() {
            const currentID = window.location.pathname.replace(/\//, "");
            this.disqusCommentsID = currentID;
        },
        isSmallDevice
    },
    created() {
        this.getComments();
    },
    mounted() {
        this.fetchContent();
    },
    metaInfo() {
        return {
            title: this.metaTitle,
            meta: [
                {
                    name: "description",
                    content: this.metaDescription
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: this.canonical
                }
            ]
        };
    }
};



// WEBPACK FOOTER //
// ./src/pages/Reference/Detail/ReferenceDetail.js